<template>
  <div class="specialContainer">
    <SpecialMainHeader  />
    <div class="specialcontentContainer">
      <SpecialLeftMenu :items="leftMenuItems" />
      <div id="contentPage" class="rightBox specialPage">
        <!-- Content 영역 -->
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SpecialMainHeader from "@/components/SpecialMainHeader.vue";
import SpecialLeftMenu from "@/components/SpecialLeftMenu.vue";

export default {
  components: {
    SpecialMainHeader,
    SpecialLeftMenu
  },
  data() {
    return {      
      leftMenuItems: [], // Left 메뉴 항목 저장
    };
  },
  methods: {
    
  },
  watch: {
    
  },
  mounted() {
    
  },
};
</script>

